import { render } from "./DeckPicker.vue?vue&type=template&id=5d487e81&scoped=true"
import script from "./DeckPicker.vue?vue&type=script&lang=js"
export * from "./DeckPicker.vue?vue&type=script&lang=js"

import "./DeckPicker.vue?vue&type=style&index=0&id=5d487e81&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d487e81"

export default script